import { toast } from 'vue-sonner'

const config = useRuntimeConfig()

const apiClient = $fetch.create({
  baseURL: config.public.apiUrl,
  credentials: 'include',
  async onResponseError({ response, options }) {
    if (response.status === 401) {
      const { useUser } = await import('~/stores/user/user')
      const { actions } = useUser()
      try {
        await actions.getTokens()
        await $fetch(response.url, {
          ...(options as any),
          onResponseError: undefined,
        })
      } catch (error) {
        toast.error('Please sign in again')
        await actions.signOut()
      }
      return
    }

    toast('Uh oh! Something went wrong.', {
      description: response._data?.message,
    })
  },
})

export { apiClient }
